<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/purchase/order' }">采购订单</el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑订单' : isView ? '查看订单' : '新增订单' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-tabs v-model="activeTab" type="border-card">
            <!-- 基本信息 Tab -->
            <el-tab-pane label="基本信息" name="basic">
                <el-form :model="forms" ref="forms" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购订单号" prop="billCode">
                                <el-input v-model="forms.billCode" :disabled="true || isEdit || isView"
                                    style="max-width: 220px;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="单据类型" prop="billType" style="width:350px">
                                <el-select v-model="forms.billType" placeholder="请选择" :disabled="isView">
                                    <el-option label="标准采购" value="标准采购"></el-option>
                                    <el-option label="紧急采购" value="紧急采购"></el-option>
                                    <el-option label="委外加工" value="委外加工"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="制单日期" prop="billDate">
                                <el-date-picker v-model="forms.billDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="所属公司" prop="companyID">
                                <el-tree-select ref="companys" v-model="forms.companyID" :data="companys"
                                    :disabled="!!forms.companyID" @change="companyChange();" clearable check-strictly
                                    :render-after-expand="false" style="width: 280px;" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购部门" prop="departmentID">
                                <el-tree-select ref="departments" v-model="forms.departmentID" :data="departments"
                                    clearable check-strictly :render-after-expand="false" style="width:220px"
                                    :disabled="isEdit || isView" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="外部单号" prop="externalNo">
                                <el-input v-model="forms.externalNo" :disabled="isView" style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="关联申请单" prop="requisitionBillCode">
                                <el-input v-model="forms.requisitionBillCode" :disabled="isEdit || isView"
                                    placeholder="多个用逗号分隔"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :xs="24">
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="forms.remark" type="textarea" :rows="2"
                                    :disabled="isView"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 采购信息 Tab -->
            <el-tab-pane label="采购信息" name="supplier">
                <el-form :model="forms" ref="purchaseForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购员" prop="purchaserName">
                                <el-input v-model="forms.purchaserName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购日期" prop="purchaseDate">
                                <el-date-picker v-model="forms.purchaseDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-form :model="forms" ref="supplierForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="供应商" prop="supplierCode">
                                <el-select v-model="forms.supplierCode" filterable clearable placeholder="请选择供应商"
                                    :disabled="isEdit || isView" style="width:220px" @change="supplierChange">
                                    <el-option v-for="s in suppliers" :key="s.supplierCode"
                                        :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="供应商联系人" prop="supplierContactName">
                                <el-input v-model="forms.supplierContactName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="供应商电话" prop="supplierContactPhone">
                                <el-input v-model="forms.supplierContactPhone" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 交货信息 Tab -->
            <el-tab-pane label="交货信息" name="delivery">
                <el-form :model="forms" ref="deliveryForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="交货日期" prop="deliveryDate">
                                <el-date-picker v-model="forms.deliveryDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="收货联系人" prop="deliveryContactName">
                                <el-input v-model="forms.deliveryContactName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="收货联系电话" prop="deliveryContactPhone">
                                <el-input v-model="forms.deliveryContactPhone" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24">
                            <el-form-item label="交货地点" prop="deliveryAddress">
                                <el-input v-model="forms.deliveryAddress" :disabled="isView"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 付款信息 Tab -->
            <el-tab-pane label="付款信息" name="payment">
                <el-form :model="forms" ref="amountForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="币种" prop="currency">
                                <el-select v-model="forms.currency" :disabled="isView" style="width:220px">
                                    <el-option label="人民币" value="CNY"></el-option>
                                    <el-option label="美元" value="USD"></el-option>
                                    <el-option label="欧元" value="EUR"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="汇率" prop="exchangeRate">
                                <el-input-number v-model="forms.exchangeRate" :disabled="isView" :precision="6" :min="0"
                                    style="width:220px"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="税率(%)" prop="taxRate">
                                <el-input-number v-model="forms.taxRate" :disabled="isView" :precision="2" :min="0"
                                    :max="100" style="width:220px" @change="calculateTotals"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="总数量">
                                <el-input v-model="forms.totalQuantity" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="总金额">
                                <el-input v-model="forms.totalAmount" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="含税总额">
                                <el-input v-model="forms.totalTaxAmount" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-form :model="forms" ref="paymentForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="付款方式" prop="paymentMethod">
                                <el-select v-model="forms.paymentMethod" :disabled="isView" style="width:220px">
                                    <el-option label="现结" value="现结"></el-option>
                                    <el-option label="预付款" value="预付款"></el-option>
                                    <el-option label="月结" value="月结"></el-option>
                                    <el-option label="账期" value="账期"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="16">
                            <el-form-item label="付款条件" prop="paymentTerm">
                                <el-input v-model="forms.paymentTerm" :disabled="isView"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>

        <div style="text-align:left;margin-top:20px;">
            <el-button type="primary" icon="Select" @click="submit" v-if="!isView">保存</el-button>
            <el-button icon="Back" @click="back">返回</el-button>
        </div>

        <!-- 订单明细 -->
        <div style="margin-top: 15px;">
            <el-card>
                <template #header>
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <div>采购订单明细</div>
                        <div>
                            <el-button plain icon="Plus" type="primary" size="small" @click="addDetail" v-if="!isView"
                                :disabled="isEdit">
                                新增明细
                            </el-button>

                            <el-dropdown v-if="!isView" style="margin:0px 10px;" size="small">
                                <el-button plain icon="Upload" type="primary" size="small">
                                    数据操作
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item :disabled="isEdit">导入明细</el-dropdown-item>
                                        <el-dropdown-item>下载模板</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </div>
                </template>

                <el-table ref="detailTable" :data="visibleDetails" stripe border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" label="行号" width="55"></el-table-column>
                    <el-table-column prop="detailImg" label="图片" width="60">
                        <template v-slot="scope">
                            <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'" :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                                <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productCode" label="货品信息" width="160">
                        <template #default="{ row }">
                            <el-autocomplete v-model="row.productSearchText"
                                :fetch-suggestions="(queryString, cb) => searchProductAsync(queryString, cb, row)"
                                placeholder="输入货品编号/名称/条码搜索" :disabled="true || isView"
                                @select="(item) => handleProductSelect(item, row)" size="small" style="width:100%"
                                :trigger-on-focus="false" :debounce="300">
                                <template #default="{ item }">
                                    <div style="display: flex; justify-content: space-between;">
                                        <span style="font-weight: bold;">{{ item.detailCode }}</span>
                                        <span style="">{{ item.serialCode }}</span>
                                        <span style="color: #8492a6; font-size: 12px;">{{ item.detailName }}</span>
                                    </div>
                                </template>
                            </el-autocomplete>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requisitionBillCode" label="来源申请单" width="180" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-text size="small">{{ row.requisitionBillCode || '-' }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="货品名称" width="200" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-text size="small">{{ row.productName || '-' }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierCode" label="供货工厂" width="130">
                        <template #default="{ row }">
                            <el-select v-model="row.supplierCode" filterable clearable placeholder="供应商"
                                :disabled="isView" style="width:100%" size="small" @change="(value) => {
                                    const selected = suppliers.find(s => s.supplierCode === value);
                                    row.supplierName = selected ? selected.supplierName : '';
                                }">
                                <el-option v-for="s in suppliers" :key="s.supplierCode"
                                    :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierProductCode" label="工厂款号" width="110">
                        <template #default="{ row }">
                            <el-input v-model="row.supplierProductCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productSpec" label="规格型号" width="150">
                        <template #default="{ row }">
                            <el-input v-model="row.productSpec" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitName" label="单位" width="80">
                        <template #default="{ row }">
                            <el-input v-model="row.unitName" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderQuantity" label="订单数量" width="130">
                        <template #default="{ row }">
                            <el-input-number v-model="row.orderQuantity" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitPrice" label="单价" width="130">
                        <template #default="{ row }">
                            <el-input-number v-model="row.unitPrice" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" width="70">
                        <template #default="{ row }">
                            <span>{{ row.amount || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" label="税率(%)" width="120">
                        <template #default="{ row }">
                            <el-input-number v-model="row.taxRate" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0" :max="100"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxTotalAmount" label="含税金额" width="85">
                        <template #default="{ row }">
                            <span>{{ row.taxTotalAmount || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requiredDate" label="要求到货" width="130">
                        <template #default="{ row }">
                            <el-date-picker v-model="row.requiredDate" type="date" size="small" :disabled="isView"
                                format="YYYY-MM-DD" style="width:100%"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeCode" label="收货仓库" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.storeCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200">
                        <template #default="{ row }">
                            <el-input v-model="row.remark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" fixed="right">
                        <template #default="{ row, $index }">
                            <el-button @click="deleteDetailRow($index)" link size="small" type="danger"
                                v-if="!isView">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

    </el-card>
</template>

<script>
import { fetchBillCode, fetchPurchaseSupplier } from '@/api/purchase'
import { searchSkuList } from '@/api/product'

export default {
    name: 'PurchaseOrderBill',
    components: {},
    data() {
        return {
            apiUrl: '',
            activeTab: 'basic',
            companys: [],
            departments: [],
            suppliers: [],

            details: [],
            forms: {
                billDate: new Date(),
                status: 0,
                totalQuantity: 0,
                totalAmount: 0,
                taxRate: 13,
                taxAmount: 0,
                totalTaxAmount: 0,
                currency: 'CNY',
                exchangeRate: 1,
                deliveryStatus: 0,
                closeStatus: 0,
                companyID: '',
                companyName: '',
                departmentID: '',
                departmentName: '',
                billCode: '',
                billType: '',
                externalNo: '',
                requisitionBillCode: '',
                supplierId: '',
                supplierCode: '',
                supplierName: '',
                supplierContactName: '',
                supplierContactPhone: '',
                purchaserName: '',
                purchaseDate: null,
                deliveryDate: null,
                deliveryAddress: '',
                deliveryContactName: '',
                deliveryContactPhone: '',
                paymentMethod: '',
                paymentTerm: '',
                remark: ''
            },
            detailQuery: {
                page: 1,
                rows: 1000,
                filters: [],
                sidx: 'lineNo',
                sord: 'asc'
            }
        }
    },
    computed: {
        isEdit() { return this.$route.query.id && this.$route.query.mode !== 'view' },
        isView() { return this.$route.query.mode === 'view' },
        billId() { return this.$route.query.id },
        // 过滤未删除的明细数据
        visibleDetails() {
            return this.details.filter(detail => !detail.deleteMark);
        }
    },
    mounted() {
        this.apiUrl = process.env.VUE_APP_BASEURL;
        this.$kaung.init(this.$options.name);

        this.$kaung.companys().then((res) => {
            this.companys = res;
            this.companyChange();
        });

        fetchPurchaseSupplier().then((res) => {
            if (res && res.code === 200) {
                this.suppliers = Array.isArray(res.data) ? res.data : []
            }
        });

        if (this.billId) {
            this.load();
        } else {
            fetchBillCode(this.$options.name).then(res => {
                this.forms.billCode = res.data || '';
                this.forms.billType = '常规采购';
                this.forms.purchaserName = this.$store.getters.getUserInfo.realName || this.$store.getters.getUserInfo.userName || '';
                this.forms.companyID = this.$store.getters.getUserInfo.companyID || '';
                this.forms.departmentID = this.$store.getters.getUserInfo.departmentID || ''
                this.companyChange(this.forms.departmentID);
            })
        }
    },
    methods: {
        // 搜索货品信息
        searchProductAsync(queryString, callback, row) {
            if (!queryString || queryString.trim().length < 2) {
                callback([]);
                return;
            }

            searchSkuList(queryString).then(res => {
                if (res && res.data && res.data.data) {
                    const suggestions = res.data.data.map(item => ({
                        value: `${item.detailName} [${item.detailCode}]${item.serialCode ? ' [' + item.serialCode + ']' : ''}`,
                        ...item
                    }));
                    callback(suggestions);
                } else {
                    callback([]);
                }
            }).catch(err => {
                console.error('Product search error:', err);
                callback([]);
            });
        },
        // 选择货品后填充信息
        handleProductSelect(item, row) {
            if (!item) return;

            row.productId = item.id || '';
            row.productCode = item.serialCode || item.brandModelCode || item.factoryModelCode || '';
            row.productName = item.detailName || '';
            row.productSpec = item.detailUnit || '';
            row.productBarcode = item.brandModelCode || item.factoryModelCode || item.serialCode || '';
            row.unitName = item.unitName || '';
            row.detailId = item.id || '';
            row.detailCode = item.detailCode || '';
            row.detailName = item.detailName || '';

            // 设置搜索文本为货品编号，便于显示和编辑
            row.productSearchText = item.detailCode || item.serialCode || item.brandModelCode || item.factoryModelCode || '';

            row.supplierCode = item.factoryCode || '';
            row.supplierName = item.factoryName || '';
            row.supplierProductCode = item.factoryModelCode || '';

            // 如果已设置订货数量，触发重新计算
            if (row.orderQuantity > 0) {
                this.onDetailChange(row);
            }

            this.$message.success('货品信息已填充');
        },
        load() {
            this.$kaung.getone(this.billId).then(res => {
                if (res.code === 200)
                    this.forms = { ...res.data };

                this.companyChange(this.forms.departmentID);
            });

            this.fetchDetails();
        },
        fetchDetails() {
            this.$kaung.fetch({ url: 'PurchaseOrderDetail/GetDetailList', params: { billId: this.billId }, method: 'get' })
                .then(res => {
                    if (res && res.code === 200) {
                        // 初始化productSearchText为productCode，用于autocomplete显示
                        this.details = res.data.map(item => ({
                            ...item,
                            productSearchText: item.detailCode || item.productCode || ''
                        }));
                    }
                })
        },
        addDetail() {
            const newDetail = {
                id: null,
                billId: this.billId || '',
                lineNo: this.details.length + 1,
                productCode: '',
                productName: '',
                productSpec: '',
                unitName: '',
                productSearchText: '', // 用于autocomplete的搜索文本
                orderQuantity: 0,
                unitPrice: 0,
                amount: 0,
                taxRate: this.forms.taxRate || 13,
                taxAmount: 0,
                taxPrice: 0,
                taxTotalAmount: 0,
                deliveredQuantity: 0,
                remainQuantity: 0,
                requiredDate: '',
                supplierCode: this.forms.supplierCode,
                supplierName: this.forms.supplierName,
                storeCode: '',
                storeName: '',
                status: 0,
                remark: '',
                deleteMark: false,
                _isNew: true
            }

            this.details.push(newDetail)
        },

        submit() {
            // 计算总计
            this.calculateTotals();

            // 首先验证表单
            this.$refs.forms.validate((valid) => {
                if (!valid) {
                    this.$message.error('请完善必填信息');
                    return false;
                }

                // 验证明细数据
                if (!this.details || this.details.length === 0) {
                    this.$message.error('请至少添加一条采购明细');
                    return false;
                }

                // 验证明细必填字段
                for (let i = 0; i < this.details.length; i++) {
                    const detail = this.details[i];
                    if (!detail.productCode || !detail.productName) {
                        this.$message.error(`第 ${i + 1} 行：货品编号和货品名称不能为空`);
                        return false;
                    }
                    if (!detail.orderQuantity || detail.orderQuantity <= 0) {
                        this.$message.error(`第 ${i + 1} 行：数量必须大于0`);
                        return false;
                    }
                }

                // 保存数据
                this.$kaung.post({ url: '/' + this.$options.name + '/ModifyForms', data: { master: this.forms, details: this.details } }).then(res => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.back();
                    }
                }).catch(err => {
                    this.$message.error('提交失败：' + (err.message || '未知错误'));
                });
            });
        },
        back() { this.$router.back() },

        companyChange(departmentID) {
            this.forms.departmentID = departmentID || '';
            this.departments = [];
            var that = this;
            if (this.forms.companyID) {
                this.$kaung.departments(this.forms.companyID).then((res) => {
                    that.departments = res;
                });
            }
        },

        supplierChange() {
            const supplier = this.suppliers.find(s => s.supplierCode === this.forms.supplierCode);
            if (supplier) {
                this.forms.supplierId = supplier.id || '';
                this.forms.supplierName = supplier.supplierName || supplier.text || '';
            }
        },

        onDetailChange(row) {
            const quantity = Number(row.orderQuantity) || 0;
            const price = Number(row.unitPrice) || 0;
            const taxRate = Number(row.taxRate) || 0;

            // 计算金额（未税）
            row.amount = (quantity * price).toFixed(2);

            // 计算税额
            row.taxAmount = (row.amount * taxRate / 100).toFixed(2);

            // 计算含税单价
            row.taxPrice = (price * (1 + taxRate / 100)).toFixed(2);

            // 计算含税金额
            row.taxTotalAmount = (parseFloat(row.amount) + parseFloat(row.taxAmount)).toFixed(2);

            // 计算剩余数量
            row.remainQuantity = quantity - (row.deliveredQuantity || 0);

            // 重新计算总计
            this.calculateTotals();
        },

        calculateTotals() {
            let totalQty = 0;
            let totalAmt = 0;
            let totalTaxAmt = 0;

            // 只计算未删除的明细
            this.details.forEach(detail => {
                if (!detail.deleteMark) {
                    totalQty += Number(detail.orderQuantity) || 0;
                    totalAmt += Number(detail.amount) || 0;
                    totalTaxAmt += Number(detail.taxTotalAmount) || 0;
                }
            });

            this.forms.totalQuantity = totalQty.toFixed(2);
            this.forms.totalAmount = totalAmt.toFixed(2);
            this.forms.taxAmount = (totalTaxAmt - totalAmt).toFixed(2);
            this.forms.totalTaxAmount = totalTaxAmt.toFixed(2);
        },

        deleteDetailRow(index) {
            this.$confirm('确定要删除该明细行吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 假删除：标记为删除而不是真正从数组中移除
                // 因为表格使用visibleDetails，所以需要找到原始details中对应的项
                const visibleItem = this.visibleDetails[index];
                const originalIndex = this.details.findIndex(d => d === visibleItem);
                
                if (originalIndex !== -1) {
                    this.details[originalIndex].deleteMark = true;
                    this.calculateTotals();
                    this.$message({ type: 'success', message: '已删除' });
                }
            }).catch(() => { })
        }
    }
}
</script>

<style scoped>
.el-tabs {
    margin-bottom: 20px;
}

:deep(.el-tabs__content) {
    padding: 20px 10px;
}

:deep(.el-tab-pane) {
    min-height: 200px;
}
</style>
